<!--
 * @Author: your name
 * @Date: 2021-12-21 14:43:07
 * @LastEditTime: 2024-03-26 09:53:00
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\children\SetFontSize.vue
-->
<template>
  <el-select v-model="textSize" filterable :filter-method="filterMethod" @blur="submit" @keyup.enter.native="submit" :placeholder="$t('basics.PleaseSelect')" size="mini" ref="fontSize">
    <el-option v-for="item in fontSizeList" :key="item" :label="item+'px'" :value="item"></el-option>
  </el-select>
</template>

<script>
import fontSizeList from '@static/data/fontSize.js';
export default {
  name: "SetFontSize",
  props: {
    defaultSize: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      fontSizeList,
      textSize: 0,
      fontSize: 0,
    }
  },
  created() {
    this.textSize = this.defaultSize + "px";
  },
  methods: {
    filterMethod(val) {
      this.fontSize = val;
    },
    // blur() {
    //   if (parseInt(this.fontSize)) {
    //     this.textSize = parseInt(this.fontSize) + "px";
    //     this.fontSize = 0;
    //   }
    // },
    submit() {
      if (parseInt(this.fontSize)) {
        this.textSize = parseInt(this.fontSize) + "px";
        this.fontSize = 0;
      }
    }
  },
  watch: {
    textSize: {
      handler(nVal) {
        this.$emit('setFontSize', parseInt(nVal));
        this.$refs.fontSize.blur();
      }
    },
    defaultSize: {
      handler(nVal) {
        this.textSize = nVal + "px";
      }
    }
  }
}
</script>

<style>
</style>